import { concatLatestFrom, ofType } from '@ngrx/effects';
import { MonoTypeOperatorFunction, pipe } from 'rxjs';
import { filter, map, takeUntil } from 'rxjs/operators';
import { TranslatableEffect } from '../../i18n/TranslatableEffects';
import { LoadCompositesActionType, UpdateActivityPayload } from '../composite/composite.actions';
import { NavigationPages, NavigationSelectors } from '../navigation/navigation.selectors';
import { CoreActions } from './core.actions';

export class BaseEffects extends TranslatableEffect {
  protected takeUntilNavigationStart = <T>(): MonoTypeOperatorFunction<T> =>
    takeUntil(this.actions$.pipe(ofType(CoreActions.navigationStart)));

  protected whenCurrentUrl = <T>(navigation: NavigationPages): MonoTypeOperatorFunction<T> =>
    pipe(
      concatLatestFrom(() => this.store.select(NavigationSelectors.currentUrl)),
      filter(([, currentUrl]) => currentUrl.startsWith(navigation)),
      map(([data]) => data),
    );

  protected whenOnCompositeUrl = <
    T extends LoadCompositesActionType | UpdateActivityPayload,
  >(): MonoTypeOperatorFunction<T> =>
    pipe(
      concatLatestFrom(() => this.store.select(NavigationSelectors.currentUrl)),
      filter(([{ compositeType }, currentUrl]) => `/${compositeType}` === currentUrl),
      map(([action]) => action),
    );
}
